import { MessageCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface HelpFabProps {
  onClick: () => void;
  className?: string;
}

export function HelpFab({ onClick, className }: HelpFabProps) {
  return (
    <button
      onClick={onClick}
      aria-label="Öppna hjälpcenter"
      className={cn(
        "fixed bottom-4 right-4 z-40 h-12 w-12 rounded-full bg-primary text-primary-foreground shadow-lg",
        "flex items-center justify-center hover:scale-105 active:scale-95 transition-transform",
        "ring-1 ring-primary/30",
        className,
      )}
    >
      <MessageCircle className="h-5 w-5" />
    </button>
  );
}
